import { lightTheme } from '@/customTheme'
import { hexToRgba } from '@/scenes/engine/utils/utils'
import { styled } from 'styletron-react'
import { forwardRef } from 'react'

export enum RoundedType {
  ROUND = 'round',
  ROUNDED_RECTANGLE = 'roundedRectangle'
}

const Wrapping = styled('div', (props: {$rounded: RoundedType}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px',
  gap: '4px',
  height: '40px',
  background: lightTheme.colors.white,
  borderRadius: props.$rounded === RoundedType.ROUND ? '100px' : '12px',
  boxShadow: `0 0 6px 0 ${hexToRgba(lightTheme.colors.black, 0.08)}`
}))

type WrappingFloatingInspectorProps = {
  id?: string
  style?: React.CSSProperties
  rounded?: RoundedType
  children: React.ReactNode
}

const WrappingFloatingInspector = forwardRef<HTMLDivElement, WrappingFloatingInspectorProps>(
  ({ id, style, rounded = RoundedType.ROUNDED_RECTANGLE, children }, ref) => {
    return (
      <Wrapping ref={ref} id={id} style={style} $rounded={rounded}>{children}</Wrapping>
    )
  }
)

WrappingFloatingInspector.displayName = 'WrappingFloatingInspector'

export default WrappingFloatingInspector